export default __webpack_public_path__ + "static/GB-home-2388fe5db86029c203edcf8d1dbd747a.jpg";